export default __webpack_public_path__ + "static/3-444dec077af1206e467e9838d58e9adb.svg";